import { colorPalette } from "@command-center-app/utils/colorPalette";

export const getButtonStyle = (
  type: "contained" | "outlined" | "text",
  backgroundColor: string
): any => ({
  backgroundColor,
  border:
    type === "outlined" ? `1px solid ${colorPalette.colorPureBlack}` : "none",
  textTransform: "none",
  "&:hover": {
    backgroundColor,
    border:
      type === "outlined" ? `1px solid ${colorPalette.colorPureBlack}` : "none",
  },
});

export const tableStyle: any = {
  cellStyle: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
  dataTextRegular: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
  },
  dataTextMedium: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
  },
  dataTextSmall: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    color: colorPalette.colorGrayishBlue,
    display: "flex",
    alignItems: "center",
  },
  imageStyle: {
    borderRadius: "5px",
    objectFit: "contain",
    height: "52px",
    width: "52px",
    minWidth: "52px",
    border: `1px solid ${colorPalette.colorLightGrayishBlue}`,
  },
  bigColumn: {
    minWidth: "90px",
    width: "90px",
  },
  smallColumn: {
    minWidth: "10px",
    width: "10px",
  },

};

export const modalStyle: any = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: `2px solid ${colorPalette.colorPureBlack}`,
  boxShadow: 24,
  headerStyle: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 600,
  },
};

export const imageGallery: any = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "16px",
  imageContainer: {
    position: "relative",
    display: "inline",
  },
  defaultImageStyle: {
    width: "100%",
    height: "146px",
    objectFit: "cover",
    border: "1px solid #E5E7E8",
    position: "relative",
    top: "-47px",
    zIndex: 99,
  },
  thumbnailContainer: {
    display: "flex",
    gap: "10px",
    width: "100%",
    marginTop: "-40px",
  },
};

export const imageUploader: any = {
  imageUploaderContainer: {
    width: "200px",
    border: "1px dashed #D6D8DB",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  fileUploadContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  imageStyle: {
    margin: "auto",
    paddingBottom: "8px",
  },
  uploaderDetailsTextStyle: {
    textAlign: "center",
    paddingTop: "2px",
    fontFamily: "Inter !important",
    fontWeight: 200,
  },
  uploaderTitleTextStyle: {
    fontSize: "14px",
    fontWeight: 600,
    color: colorPalette.colorPureBlack,
  }
};

export const imageListStyle: any = {
  imageListContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "10px",
  },
  imageContainerStyle: {
    flexShrink: 0,
    width: 180,
    marginRight: 2,
  },
  imageStyle: {
    width: "100%",
    objectFit: "conatin",
  },

  lableText: {
    fontFamily: "Inter",
    fontWeight: "200px !important",
  },
  actionContainer: {
    display: "flex",
    flexDirection: "row",
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
    gap: 1,
  },
  actionIconStyle: {
    width: 34,
    height: 34,
    background: "#fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
